import getConfig from "config";
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = getConfig().GA_ID || "";

export const initAnalytics = () => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
};


export const trackPageView = (path: string) => {
    ReactGA.send({
        hitType: "pageview",
        page: path
    });
};

export const trackEvent = (
    category: string,
    action: string,
    label?: string
) => {
    ReactGA.event({
        category,
        action,
        label
    });
};